<!-- 中间内容页，显示不同模块 -->
<template>
  <div class="row">
    <div v-for="(module, index) in moduleList">
      <!-- 轮播图 -->
      <index-carousel
        v-if="module.content_module_type===1"
        :module="module"
        :key="module.course_skip_category_id">
      </index-carousel>
      <!-- 直播 -->
      <class-section-live
        v-if="module.content_module_type===3"
        :module="module"
        :key="module.course_skip_category_id">
      </class-section-live>
      <!-- 课程 -->
      <class-section
        v-if="module.content_module_type===4"
        :module="module"
        :key="module.course_skip_category_id">
      </class-section>
    </div>
  </div>
</template>

<script>
import urls from '../../common/js/urls.js'
import IndexCarousel from "./IndexCarousel"        //轮播图
import ClassSectionLive from "./ClassSectionLive"  //近期直播
import ClassSection from "./ClassSection"          //课程
import ClassSectionOffline from "./ClassSectionOffline"   //线下班
import {api_content_operation_page} from "../../networks/ContentOperationHandler"
import {api_content_sy_page} from "../../networks/ContentOperationHandler"

export default {
  // metaInfo: {
  //     title: '公考面试_公务员培训-必胜公考', // set a title
  //     meta: [
  //       {                 // set meta
  //         name: 'keywords',
  //         content: '公务员面试，公考面试，公务员面试培训'
  //       },
  //       {                 // set meta
  //         name: 'description',
  //         content: '必胜公考视频培训教程，在线免费试听，公务员考试面试培训班，面试系统课、面试备考指导、面试考情分析、面试礼仪及考试流程、面试专题突破，应有尽有，快点击了解'
  //       }
  //     ],
  //   },
  name: 'module',
  components: {
    IndexCarousel,   //轮播图
    ClassSectionLive,//近期直播
    ClassSection,    //课程
    ClassSectionOffline  //线下班
  },
  data() {
    return {
      moduleList: [],
    }
  },
  computed: {
    current_page_id() {
      return this.$route.params.page_id || this.$store.state.index_module_page_id;
    },
  },
  created: function () {
    var context = this;
    var promise = api_content_sy_page(context);
    promise.then(function (r) {
      context.newPage(r["page_content"]);
    }).catch(function (error) {
    });
  },
  watch: {
    current_page_id: function (val) {
      this.initPage(this.current_page_id);
    },
  },
  methods: {
    initPage: function (page_id) {
      var context = this;
      var promise = api_content_operation_page(context, page_id);
      promise.then(function (r) {
        context.newPage(r["page_content"]);
      }).catch(function (error) {
      });
    },
    newPage: function (page_content) {
      var _this = this
      let index_page_id = this.$store.state.index_module_page_id;
      _this.moduleList = []; //模块列表
      if ($.isEmptyObject(page_content)) {
        return;
      }
      var modules = page_content.page.modules;
      for (var i = 0; i < modules.length; i++) {
        var module = modules[i];
        switch (module.content_module_type) {
          case 1: //轮播图
            _this.moduleList.push(module)
            break;
          case 3: // 直播课
            _this.moduleList.push(module)
            break;
          case 4: // 课程
            _this.moduleList.push(module)
            break;
          case 5: // 线下课程
            _this.moduleList.push(module)
            break;
          // case 6:
          //   _this.moduleList.push(module)
          //   break;
        }
      }
    },
  }
}
</script>

<style scoped>
.mt15 {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/ModuleTemplate.vue